// src/mime.ts
var JSON = "application/json";
var CSV = "text/csv";
var ICAL = "text/calendar";
var PDF = "application/pdf";

// src/preference.ts
import { NO_PREF } from "@overbookd/preference";
var DEFAULT_PREFERENCE = {
  paperPlanning: null,
  assignment: NO_PREF,
  favoritePages: []
};

// src/image.ts
var IMAGE_MAX_SIZE = 1024 * 1024 * 2;
var IMAGE_EXTENSIONS = ["image/png", "image/jpeg", "image/gif"];
export {
  CSV,
  DEFAULT_PREFERENCE,
  ICAL,
  IMAGE_EXTENSIONS,
  IMAGE_MAX_SIZE,
  JSON,
  PDF
};
